import {ProjectViewColumnState} from './ProjectViewColumnState';

export const columnStateKeyToGridField: Record<
  keyof ProjectViewColumnState,
  string
> = {
  clientName: 'clientName',
  projectName: 'projectName',
  icons: 'icons',
  engagementCode: 'engagementCode',
  alphaCode: 'alphaCode',
  clientPreferredId: 'clientPreferredId',
  domainCountryCode: 'domainCountryCode',
  highlyConfidential: 'highlyConfidential',
  ecaEnabled: 'ecaEnabled',
  hasAlerts: 'hasAlerts',
  branchName: 'branchName',
  departmentName: 'departmentName',
  dataDeliveries: 'dataDeliveriesCount',
  datasetsProcessing: 'dataProcessingGb',
  processedDatasets: 'processedDatasetsGb',
  productionsCompleted: 'productionsCompletedCount',
  reviewWorkspaceUsers: 'reviewWorkspaceUsersCount',
  totalDataUnderManagement: 'totalDataUnderManagementGb',
};

const gridFieldToColumnStateKey = Object.entries(
  columnStateKeyToGridField
).reduce<Record<string, keyof ProjectViewColumnState>>(
  (mapping, [stateKey, gridField]) => {
    mapping[gridField] = stateKey as keyof ProjectViewColumnState;
    return mapping;
  },
  {}
);

export const toColumnStateKey = (
  gridField: string
): keyof ProjectViewColumnState =>
  gridFieldToColumnStateKey[gridField] ??
  (gridField as keyof ProjectViewColumnState);

export const toGridField = (stateKey: keyof ProjectViewColumnState): string =>
  columnStateKeyToGridField[stateKey];

export const normalizeColumnState = (
  state: Partial<ProjectViewColumnState> & Record<string, boolean | undefined>,
  defaultState: ProjectViewColumnState
): ProjectViewColumnState => {
  const normalized = {...defaultState};

  (Object.keys(defaultState) as Array<keyof ProjectViewColumnState>).forEach(
    (key) => {
      const gridField = columnStateKeyToGridField[key];

      if (gridField !== key && typeof state[gridField] === 'boolean') {
        normalized[key] = state[gridField] as boolean;
        return;
      }

      if (typeof state[key] === 'boolean') {
        normalized[key] = state[key] as boolean;
      }
    }
  );

  return normalized;
};

export const toColumnVisibilityModel = (
  state: ProjectViewColumnState
): Record<string, boolean> =>
  (Object.keys(state) as Array<keyof ProjectViewColumnState>).reduce<
    Record<string, boolean>
  >((model, key) => {
    model[columnStateKeyToGridField[key]] = state[key];
    return model;
  }, {});
